import { useRouter } from 'next/router'
import { useEffect } from 'react'

export const usePreserveScroll = () => {
	const router = useRouter()

	useEffect(() => {
		const handleRouteChange = () => {
			sessionStorage.setItem(router.asPath, window.scrollY.toString())
		}
		router.events.on('routeChangeStart', handleRouteChange)
		return () => {
			router.events.off('routeChangeStart', handleRouteChange)
		}
	}, [router.events])

	useEffect(() => {
		if (router.asPath in sessionStorage) {
			setTimeout(() => {
				window.scrollTo({ top: Number(sessionStorage.getItem(router.asPath)), behavior: 'smooth' })
				sessionStorage.removeItem(router.asPath)
			}, 200)
		}
	}, [])
}
